import { Page } from "@/models/page-models/Page";

export const ProductsCreate: Page = {
  "path": "products/create",
  "name": "Create Product",
  "props": {
    "data": {
      "title": "Create Product",
      "printable": "FALSE",
      "url": "products/create",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.product.customer.name",
                  "label": "Customer",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,customerAlias,{{formData.product.customer}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.alias",
                  "label": "Product Alias",
                  "disabled": "TRUE",
                  "inputType": "formula",
                  "formula": "fn(HELPER_FN,productDescription,{{formData.product}})"
                },
                {
                  "type": "input",
                  "variable": "formData.product.customerItemId",
                  "label": "Customer Item Code",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.productLine}}"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Customer Specs"
        },
        {
          "groupItems": [
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.productLine",
                  "label": "Product Line",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "resetFormData"
                    }
                  ],
                  "onVarUpdate": [
                    {
                      "executionOrder": 2,
                      "name": "copySelectedProductLine"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.productLines.data.0.data",
                  "itemText": "name",
                  "itemValue": "name"
                }
              ]
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.product.customerSample.sampleAvailable",
                  "label": "Customer Sample Available?",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.productLine}}"
                }
              ]
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.product.customerSample.pictures",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.customerSample.sampleAvailable}}",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "picture",
                          "label": "Sample Picture",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "no-preview"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.form",
                  "label": "Form",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedShapeData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selected.data",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copySelectedShapeData"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.form}}",
                  "items": "fetchedData.selected.data.form",
                  "itemText": "title",
                  "itemValue": "title"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.shape",
                  "label": "Shape",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copySelectedShapeData"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.shapes}}",
                  "items": "fetchedData.selected.data.shapes",
                  "itemText": "title",
                  "itemValue": "title"
                }
              ]
            },
            {
              "name": "5b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.corrugatedPaper.fluteType",
                  "label": "Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.fluteType"
                },
              ],
              "showIf": "fn(LOGICAL,'{{formData.product.productLine}}',==,'Corrugated Paper')"
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "dynamicGroup",
                  "variable": "formData.product.size",
                  "label": "Size",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.size}}",
                  "items": "fetchedData.selected.data.attributes.size",
                  "config": {
                    "type": "input",
                    "variable": "__item.value",
                    "label": "__item.value",
                    "unit": "__item.unit"
                  }
                },
                {
                  "type": "label",
                  "label": "Total Diameter",
                  "unit": "mm",
                  "showIf": "{{formData.product.size.HEIGHT}}",
                  "labelType": "formula",
                  "formula": "fn(SUM,{{formData.product.size.BDIA}},fn(MULTIPLY,{{formData.product.size.HEIGHT}},2))"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Technical Specs"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.printType",
                  "label": "Printing",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Yes\",\"value\":\"Printed\"},{\"text\":\"No\",\"value\":\"Plain\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.windingDirection",
                  "label": "Winding Direction",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
                  "items": "[\"C1\",\"C2\",\"C3\",\"C4\",\"C5\",\"C6\",\"C7\",\"C8\",\"Manual\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.product.printing.design",
                  "disabled": "TRUE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "input",
                          "variable": "designName",
                          "label": "Design Name",
                          "disabled": "FALSE"
                        },
                        {
                          "type": "fileupload",
                          "variable": "designFile",
                          "label": "Artwork Proposal",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "no-preview"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.product.printing.artworkApproval.approved",
                  "label": "Artwork Approved?",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.product.printing.artworkApproval.approvalProof",
                  "label": "Customer Artwork Approval",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
              "disabled": "fn(NOT,fn(MATCH_DEPARTMENT,SALES))"
            },
            {
              "name": "8b(4)",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.product.printing.noOfColors",
                  "label": "No Of Colors",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.varnish",
                  "label": "Varnish",
                  "disabled": "FALSE",
                  "items": "[\"None\",\"Matt\",\"Glossy\",\"Tactile\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.spotVarnish",
                  "label": "Spot Varnish",
                  "disabled": "FALSE",
                  "items": "[\"None\",\"Matt\",\"Glossy\",\"Tactile\"]",
                  "dropdownType": "static"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')"
            },
            {
              "name": "8b(5)",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.lamination",
                  "label": "Lamination",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Yes\",\"value\":true},{\"text\":\"No\",\"value\":false}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.screen",
                  "label": "Screen",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Yes\",\"value\":true},{\"text\":\"No\",\"value\":false}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.foil",
                  "label": "Foil",
                  "disabled": "FALSE",
                  "items": "[\"None\",\"Gold\",\"Silver\"]",
                  "dropdownType": "static"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')"
            }
          ],
          "type": "genericGroup",
          "label": "Artwork Specs"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.plumCake.fluteType",
                  "label": "Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.fluteType"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.product.productLine}}',==,'Baking Mold'),&&,fn(LOGICAL,'{{formData.product.form}}',==,'Plum Cake'))"
            },
            {
              "name": "1b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.panettone.baseMaterial.fluteType",
                  "label": "Base Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.baseMaterial.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.baseMaterial.fluteType"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.panettone.edgeType",
                  "label": "Edge Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.edgeMaterialType}}",
                  "items": "fetchedData.selected.data.attributes.edgeMaterialType"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.panettone.hardEdgeMaterial.fluteType",
                  "label": "Edge Flute Type",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,'{{formData.product.bakingMold.panettone.edgeType}}',==,'Hard Edge')",
                  "items": "fetchedData.selected.data.attributes.hardEdgeMaterial.fluteType"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.product.productLine}}',==,'Baking Mold'),&&,fn(LOGICAL,'{{formData.product.form}}',==,'Panettone'))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.corrugatedPaper.fluteType",
                  "label": "Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.fluteType"
                },
              ],
              "showIf": "fn(LOGICAL,'{{formData.product.productLine}}',==,'Coffee Cup Sleeve')"
            },
            {
              "name": "21",
              "pageItems": [
                {
                  "type": "salesRmAlias",
                  "variable": "formData.product.rmAlias",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.showMaterialAlias}}",
                  "items": "fetchedData.rmAliases.data",
                  "productDataVariable": "formData.product"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Material Specs"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.shape",
                  "label": "Sachet Shape",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.sachetStructure",
                  "label": "Sachet Structure",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.tissueLength",
                  "label": "Tissue Length",
                  "unit": "mm",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.tissueWidth",
                  "label": "Tissue Width",
                  "unit": "mm",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,'{{formData.product.productLine}}',==,'Wet Wipes')",
          "label": "Wet Wipes Specs"
        },
        {
          "groupItems": [
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "custom_PackingMode",
                  "variable": "formData.product.packingMode",
                  "label": "Packing Mode",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.productLine}}",
                  "config": {
                    "sellingUnit": "formData.product.unit.unit2",
                    "productLine": "fetchedData.selected"
                  }
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Packing Specs"
        },
        {
          "groupItems": [
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.product.hasFOC",
                  "label": "Has FOC",
                  "disabled": "fn(NOT,fn(MATCH_ROLE,Sales | Manager))",
                  "showIf": "{{formData.product.productLine}}"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Commercial Specs"
        },
        {
          "groupItems": [
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Back",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "redirectToProductMaster"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "error"
                },
                {
                  "type": "button",
                  "label": "Save As Draft",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDraftFlag",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDraftFlag",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copyDraftFlag"
                    },
                    {
                      "executionOrder": 2,
                      "name": "CreateProduct",
                      "pageFunction": {
                        "name": "CreateProduct",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/insert",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "fnsAfterSubmit",
                        "arg3Value": "redirectToProductMaster"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getProductLines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=product-lines1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productLines"
        },
        "name": "getProductLines"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultProductDetails"
      },
      {
        "executionOrder": 2,
        "name": "getCustomerData"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyProductForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getProductForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productForm"
        },
        "name": "copyProductForm",
        "executeIf": "fn(LOGICAL,{{__query.duplicate}},>,-1)"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getDuplicateProductData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.duplicateProduct",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.productForm",
          "arg4Key": "fnsAfterSubmit",
          "arg4Value": "[{\"executionOrder\":1,\"name\":\"copyDuplicateProductDetails\"},{\"executionOrder\":2,\"name\":\"copyPrintedStatus\"}]"
        },
        "name": "getDuplicateProductData",
        "executeIf": "fn(LOGICAL,{{__query.duplicate}},>,-1)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllRmAliases",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/rm-alias/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.rmAliases"
        },
        "name": "getAllRmAliases"
      }
    ],
    "functions": [
      {
        "name": "getCustomerData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers/{{__query.customer}}",
        "arg2Key": "storeInVar",
        "arg2Value": "formData.product.customer",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "transformCustomerData"
      },
      {
        "name": "transformCustomerData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "name": "__selectedObject.data.name",
          "_id": "__selectedObject.data._id",
          "alias": "__selectedObject.data.alias",
          "active": "__selectedObject.data.active"
        }
      },
      {
        "name": "resetFormData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "formData.product",
        "arg2Key": "sourceFn",
        "arg2Value": "getFormValues",
        "arg3Key": "destinationKey",
        "arg3Value": "formData.product"
      },
      {
        "name": "getFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "{{__selectedObject.customer}}",
          "productLine": "{{__selectedObject.productLine}}",
          "packingMode": "[]"
        },
        "useFormula": true
      },
      {
        "name": "copySelectedProductLine",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selected",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "copySelectedShapeData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selected.data",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "redirectToProductMaster",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/product-master/{{__query.customer}}"
      },
      {
        "name": "getDefaultProductDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "{}",
          "packingMode": "[]"
        },
        "useFormula": true
      },
      {
        "name": "copyDefaultProductDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDefaultProductDetails",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.product"
      },
      {
        "name": "copyDuplicateProductDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.duplicateProduct.data",
        "arg2Key": "sourceFn",
        "arg2Value": "getDuplicateProductDetails",
        "arg3Key": "destinationKey",
        "arg3Value": "formData.product",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object",
        "arg5Key": "append",
        "arg5Value": "TRUE"
      },
      {
        "name": "getDuplicateProductDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "{{formData.product.customer}}",
          "productLine": "{{__selectedObject.productLine}}",
          "minimumQuantity": "{{__selectedObject.minimumQuantity}}",
          "unit": "{{__selectedObject.unit}}",
          "packingMode": "{{__selectedObject.packingMode}}",
          "tray": "{{__selectedObject.tray}}",
          "printing": "{{__selectedObject.printing}}",
          "wrapPaper": "{{__selectedObject.wrapPaper}}",
          "wetWipes": "{{__selectedObject.wetWipes}}",
          "shape": "{{__selectedObject.shape}}",
          "form": "{{__selectedObject.form}}",
          "bakingMold": "{{__selectedObject.bakingMold}}",
          "rmAlias": "{{__selectedObject.rmAlias}}",
          "size": "{{__selectedObject.size}}"
        },
        "useFormula": true
      },
      {
        "name": "getPrintedStatus",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "printType": "fn(CONDITIONAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.duplicateProduct.data.structure}},'),==,'Multi'),||,fn(LOGICAL,fn(LENGTH,{{formData.product.printing.design}}),>,0)),Printed,Plain)",
          "lamination": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.duplicateProduct.data.structure}},'),==,'Multi')"
        },
        "useFormula": true
      },
      {
        "name": "copyPrintedStatus",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getPrintedStatus",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.product.printing",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "__query.duplicate"
        }
      },
      {
        "name": "getDraftFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "isDraft": true
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE",
  "visible": false,
  "routerPriority": 100
}